var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/components/feature/connections/NotForSale/ButtonUpsell/ButtonUpsellWrapper.jsx";

import React from 'react';
import PropTypes from 'prop-types';
import ButtonUpsellTemplate from './ButtonUpsellTemplate';
import { useOnsiteMessagingClickstreamImpressionEvent } from '../../../../internal/OnsiteMessageEventingHooks/useOnsiteMessagingClickstreamImpressionEvent';
import { useOnsiteMessagingClickstreamIntentToShowEvent } from '../../../../internal/OnsiteMessageEventingHooks/useOnsiteMessagingClickstreamIntentToShowEvent';
import { formNewLaneEventPayload } from '../../../../../eventing/newLaneEventPayload';
import { CLICKSTREAM_EVENT_TYPE } from '../../../../../eventing/clickStreamEventSchema';
import { ClickstreamEvent } from '../../../../../eventing/ClickstreamEvent';
export var ButtonUpsell = function ButtonUpsell(_ref) {
  var actionText = _ref.actionText,
      actionSubText = _ref.actionSubText,
      actionLink = _ref.actionLink,
      trackingParameter = _ref.trackingParameter,
      zpid = _ref.zpid,
      buttonType = _ref.buttonType,
      target = _ref.target,
      additionalProps = _ref.additionalProps,
      newLaneEventData = _ref.newLaneEventData,
      additionalClickStreamData = _ref.additionalClickStreamData;
  var signalForTriggerTracking = additionalProps.signalForTriggerTracking;
  var ref = useOnsiteMessagingClickstreamImpressionEvent({
    newLaneEventData: newLaneEventData,
    additionalClickStreamData: additionalClickStreamData
  });
  useOnsiteMessagingClickstreamIntentToShowEvent({
    newLaneEventData: newLaneEventData,
    additionalClickStreamData: additionalClickStreamData,
    signalForTriggerTracking: signalForTriggerTracking
  });

  var onClick = function onClick() {
    return ClickstreamEvent(formNewLaneEventPayload(CLICKSTREAM_EVENT_TYPE.INTERACTION, newLaneEventData, additionalClickStreamData));
  };

  if (!actionText || !actionLink) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(ButtonUpsellTemplate, {
    actionText: actionText,
    actionSubText: actionSubText,
    actionLink: actionLink,
    buttonType: buttonType,
    target: target,
    trackingParameter: trackingParameter,
    zpid: zpid,
    onClick: onClick,
    additionalProps: additionalProps,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 50,
      columnNumber: 13
    }
  }));
};
ButtonUpsell.propTypes = process.env.NODE_ENV !== "production" ? {
  actionText: PropTypes.string.isRequired,
  actionSubText: PropTypes.string,
  actionLink: PropTypes.string.isRequired,
  trackingParameter: PropTypes.string,
  zpid: PropTypes.string,
  buttonType: PropTypes.string,
  target: PropTypes.string,
  additionalProps: PropTypes.shape({
    signalForTriggerTracking: PropTypes.bool
  }),
  // eslint-disable-next-line zillow/react/forbid-prop-types
  newLaneEventData: PropTypes.object,
  // eslint-disable-next-line zillow/react/forbid-prop-types
  additionalClickStreamData: PropTypes.object
} : {};
ButtonUpsell.defaultProps = {
  trackingParameter: '',
  zpid: '',
  buttonType: 'primary',
  target: '_blank',
  additionalProps: {},
  newLaneEventData: {},
  additionalClickStreamData: {},
  actionSubText: ''
};